import React from 'react';
import { useAppVersionInfo } from '@/hooks/useAppVersionInfo';

export interface AppVersionLabelProps {
  className?: string;
  style?: React.CSSProperties;
}

/**
 * The build version line shown at the bottom of the nav "More" surfaces.
 *
 * Renders nothing when the version is unknown (web builds without the env vars
 * baked in, or before the native lookup resolves) so the menus never show a
 * stray empty row.
 */
const AppVersionLabel: React.FC<AppVersionLabelProps> = ({ className, style }) => {
  const versionInfo = useAppVersionInfo();

  if (!versionInfo) return null;

  return (
    <p
      className={className}
      style={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '16px',
        color: '#999999',
        margin: 0,
        ...style,
      }}
    >
      {versionInfo}
    </p>
  );
};

export default AppVersionLabel;
